"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var servicePlanTypes_1 = require("../constants/servicePlanTypes");
var featureCategoryCodes = [servicePlanTypes_1.servicePlanTypes.BMW_CL_SERVICE_PLAN, servicePlanTypes_1.servicePlanTypes.SUB_AU_SERVICE_PLAN, servicePlanTypes_1.servicePlanTypes.MINI_CL_SERVICE_PLAN];
var dxpDataLayerFeatureService = {
    getAccessories: function (selectedFeatures) {
        return selectedFeatures.reduce(function (accessories, data) {
            if (!featureCategoryCodes.includes(data.categoryCode)) {
                accessories.push(data.shortname);
            }
            return accessories;
        }, []);
    },
    getServicePlan: function (selectedFeatures) {
        var _a;
        return (((_a = selectedFeatures.find(function (data) {
            return featureCategoryCodes.includes(data.categoryCode);
        })) === null || _a === void 0 ? void 0 : _a.shortname) || null);
    },
};
exports.default = dxpDataLayerFeatureService;
